export const RouterConst = {
  HOME: 'home',
  KINTAI: 'kintai',
  JINJI: 'jinji',
  LOGIN: 'login',
  LOGOUT: 'logout',
  TOKEN_LOGIN: 'tokenLogin',
  AUTH: 'auth',
  ForgotPassword: 'forgotPassword',
  ResetPassword: 'resetPassword',
  KINMU: 'kinmu',
  KINMU_LIST: 'kinmuList',
  HAKEN_KINMU_LIST: 'hakenKinmuList',
  GROUP_MEMBER: 'groupMember',
  SHINSEI: 'shinsei',
  SHINSEI_MENU: 'shinseiMenu',
  SHINSEI_TYPE_LIST: 'shinseiTypeList',
  SHINSEI_CREATE: 'shinseiCreate',
  SHINSEI_NO_APPROVAL: 'shinseiNoApproval',
  SHINSEI_AGAIN: 'shinseiAgain',
  SHINSEI_EDIT: 'shinseiEdit',
  SHINSEI_LIST: 'shinseiList',
  SHINSEI_DETAIL: 'shinseiDetail',
  SHINSEI_DETAIL_NO_APPROVAL: 'shinseiDetailNoApproval',
  ZANGYOU_LIST: 'zangyouList',
  PX_KINTAI_CSV: 'pxKintaiCsv',
  KOYOUKEIYAKU: 'koyoukeiyaku',
  MEIJISYO_DETAIL: 'meijisyoEdit',
  MEIJISYO_EDIT: 'meijisyoDetail',
  KOYOUKEIYAKU_MENU: 'koyoukeiyakuMenu',
  KOYOUKEIYAKU_SEARCH: 'koyoukeiyakuSearch',
  KOYOUKEIYAKU_DETAIL: 'koyoukeiyakuDetail',
  KOYOUKEIYAKU_EDIT: 'koyoukeiyakuEdit',
  KOYOUKEIYAKU_MODIFY: 'koyoukeiyakuModify',
  KOYOUKEIYAKU_PDF_DISP: 'koyoukeiyakuPdfDisp',
  SYUUGYOU_KISOKU: 'syuugyouKisoku',
  SYUUGYOU_KISOKU_LIST: 'syuugyouKisokuList',
  SYUUGYOU_KISOKU_DETAIL: 'syuugyouKisokuDetail',
  YUUKYUU_KANRI: 'yuukyuuKanri',
  YUUKYUU_KANRI_LIST: 'yuukyuuKanriList',
  YUUKYUU_KANRI_DETAIL: 'yuukyuuKanriDetail',
  YUUKYUU_KANRI_CREATE: 'yuukyuuKanriCreate',
  SYAIN: 'syain',
  SYAIN_LIST: 'syainList',
  SYAIN_DETAIL: 'syainDetail',
  SYAIN_CREATE: 'syainCreate',
  SYAIN_EDIT: 'syainEdit',
  SYAIN_FILE_DISP: 'syainFileDisp',
  MASTER: 'master',
  MST_MENU: 'mstMenu',
  MST_SYOUNIN_GROUP_CREATE: 'mstSyouninGroupCreate',
  MST_SYOUNIN_GROUP_SEARCH: 'mstSyouninGroupSearch',
  MST_SYOUNIN_GROUP_EDIT: 'mstSyouninGroupEdit',
  MST_BUKA_SEARCH: 'mstBukaSearch',
  MST_BUKA_EDIT: 'mstBukaEdit',
  ADMIN: 'admin',
  PERMISSION_ROLES_SETTING: 'permission_roles_setting',
  RENRAKU: 'renraku',
  RENRAKU_MENU: 'menu',
  RENRAKU_CREATE: 'create',
  RENRAKU_SEARCH: 'search',
  RENRAKU_DETAIL: 'detail',
  MY_TASK: 'myTask',
  OSHIRASE_LIST: 'oshiraseList',
  FURIDE_CSV_DOWNLOAD: 'furideCsvDownload',
}
